// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-allowed-to-change-plan[data-v-3e0491fe]{display:flex;flex-direction:column;height:100px;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
